import React, { useCallback } from 'react';

import { Grid } from 'e100-react-components';
import { MapInfoWindow } from 'entities/map';
import AutoNumber from './AutoNumber';
import ObuNumber from './ObuNumber';
import Coordinates from './Coordinates';
import UpdateTime from './UpdateTime';

import { Map } from 'common/utils/Map/types/map';
import { Marker } from 'common/utils/MapMarker/types';

import { useStyles } from './styles';
import { useSelectedMobileLocation } from 'features/myFleet/store';
import { useMyFleetOperations } from '../SearchCarMyFleet';

export const MobileLocationsInfoWindow = ({ map, markers }: MobileLocationsInfoWindowProps) => {
  const selectedCarEBoxLocation = useSelectedMobileLocation();
  const { resetSelectedMobileLocation } = useMyFleetOperations();
  const classes = useStyles();

  const closeInfoWindow = useCallback(() => {
    resetSelectedMobileLocation();
  }, [resetSelectedMobileLocation]);

  if (!selectedCarEBoxLocation) {
    return null;
  }

  return (
    <MapInfoWindow
      coordinates={[selectedCarEBoxLocation.latitude, selectedCarEBoxLocation.longitude]}
      map={map}
      markers={markers}
      showCloseIcon
      onClose={closeInfoWindow}
    >
      <Grid container spacing={0} classes={{ root: classes.container }}>
        <AutoNumber />
        <ObuNumber />
        <Coordinates />
        <UpdateTime />
      </Grid>
    </MapInfoWindow>
  );
};

interface MobileLocationsInfoWindowProps {
  map: Map | null;
  markers: Marker | null;
}
